<template>
    <div ref="chart" class="chart" />
</template>

<script setup lang="ts">
    const props = defineProps({
        current: {
            type: Number
        },
        max: {
            type: Number
        }
    })
    const chart = ref<HTMLElement>()
    const createChart = (el: HTMLElement, current: number, max: number) => {
        const options = {
            start: 0,
            percent: 100 / (max / current),
            size: el.getBoundingClientRect().width,
            lineWidth: 13
        }
        const radius = (options.size - options.lineWidth) / 2
        const span = document.createElement('span')
        const canvas = document.createElement('canvas')
        if (typeof G_vmlCanvasManager !== 'undefined') {
            G_vmlCanvasManager.initElement(canvas)
        }
        const ctx = canvas.getContext('2d')
        canvas.width = canvas.height = options.size
        el.appendChild(canvas)
        el.appendChild(span)
        ctx.translate(options.size / 2, options.size / 2)
        ctx.rotate((270 * Math.PI) / 180)

        const drawCircle = (color: string, lineWidth: number, start: number) => {
            ctx.beginPath()
            ctx.arc(0, 0, radius, 0, Math.PI * 2 * start)
            ctx.strokeStyle = color
            ctx.lineCap = 'round'
            ctx.lineWidth = options.lineWidth
            ctx.stroke()
        }

        drawCircle('#DBEAFE', options.lineWidth, 1)
        const animate = setInterval(() => {
            if (options.start >= options.percent) {
                clearInterval(animate)
                return
            }
            if (max > 0) {
                options.start++
                span.textContent = `${options.start}%`
                drawCircle('#3B82F6', options.lineWidth, options.start / 100)
            }
        }, 15)
    }
    onMounted(() => {
        createChart(chart.value, props.current, props.max)
    })
</script>

<style lang="scss">
.chart {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    min-width: 90px;
    height: 90px;
    min-height: 90px;

    canvas {
        display: block;
        width: 100%;
    }

    span {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        text-align: center;
        font-family: var(--accent-font);
        font-size: 14px;
        font-weight: 700;
        line-height: 1.2;
        color: var(--black-color-lighter);
        transform: translate(-50%, -50%);
    }
}
</style>
